// A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review.
import { timeFormat, timeParse } from "d3-time-format";
import { DATE_FORMAT, FREQ_FORMATS, FREQUENCIES } from "$utils/consts.js";

/** @typedef {import("./consts.js").Frequency} Frequency */

/**
 * Parse a date string into a Date object based on the given format.
 * @param {string} dateString - The date string to parse.
 * @param {Frequency} frequency - The format of the date string.
 * @returns {Date|null} - The parsed Date object, or null if parsing fails.
 */
export function parseDate(dateString, frequency = FREQUENCIES.DAILY) {
  return timeParse(FREQ_FORMATS[frequency] || DATE_FORMAT)(dateString);
}

/**
 * Format a Date object into a string based on the given format.
 * @param {Date | null} date - The Date object to format.
 * @param {Frequency} frequency - The desired output format.
 * @returns {string} - The formatted date string.
 */
export function formatDate(date, frequency = FREQUENCIES.DAILY) {
  if (!date) return "";
  return timeFormat(FREQ_FORMATS[frequency] || DATE_FORMAT)(date);
}

/**
 * Round a date to the nearest unit for the given frequency.
 * @param {Date} date - The Date object to round.
 * @param {Frequency} frequency - The desired frequency granularity.
 * @returns {Date|null} - The rounded date, or null if input is falsy.
 */
export function roundDate(date, frequency = FREQUENCIES.DAILY) {
  if (!date) return null;
  let formatted = formatDate(date, frequency);
  return parseDate(formatted, frequency);
}
